const VmiPageTypes: string[] = [
    "VmiDashboardPage",
    "VmiLocationsPage",
    "VmiLocationDetailsPage",
    "VmiBinsPage",
    "VmiBinDetailsPage",
    "VmiReportingPage",
    "VmiUsersPage",
    "VmiOrderHistoryPage",
    "VmiOrderDetailsPage",
];

export default VmiPageTypes;
